module.exports = __webpack_public_path__ + "static/assets/a5daa8623a231df5c71935c9fc570072.png";